import axios from './api'
const LoginServer = {	
	SendCode(params) {
		return axios.post(`public/smscaptcha/send`, params).then((res) => {
            return res.data
        })
	},
	Login(params) {
		return axios.post(`app/user/login`, params).then((res) => {
            return res.data
        })
	},
	LoginOut(params) {
		return axios.post(`app/user/logout`, params).then((res) => {
            return res.data
        })
	}


}
export default LoginServer


// WEBPACK FOOTER //
// ./src/api/login.js